import { marked } from 'marked';
import katex from 'katex';
import 'katex/dist/katex.min.css';

export function renderMarkdownWithMath(latex_md) {
      // Protect KaTeX delimiters from markdown parser
      let content = latex_md
        .replace(/\\\[/g, 'KATEX_BLOCK_START')
        .replace(/\\\]/g, 'KATEX_BLOCK_END')
        .replace(/\\\(/g, 'KATEX_INLINE_START')
        .replace(/\\\)/g, 'KATEX_INLINE_END');

      // Important: REMOVE breaks:true to avoid unwanted <br> tags
      let html = marked(content);

      // Restore KaTeX delimiters after markdown conversion
      html = html
        .replace(/KATEX_BLOCK_START/g, '\\[')
        .replace(/KATEX_BLOCK_END/g, '\\]')
        .replace(/KATEX_INLINE_START/g, '\\(')
        .replace(/KATEX_INLINE_END/g, '\\)');

      // Now safely render KaTeX Block math \[...\]
      html = html.replace(/\\\[(.+?)\\\]/gs, (_, tex) =>
        katex.renderToString(tex, { throwOnError: false, displayMode: true })
      );

      // Safely render KaTeX Inline math \(...\)
      html = html.replace(/\\\((.+?)\\\)/g, (_, tex) =>
        katex.renderToString(tex, { throwOnError: false, displayMode: false })
      );

      return html;
    }

/**
 * Generate a unique ID for messages and users
 */
export function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
}

/**
 * Format a date object or ISO string to a human-readable format
 */
export function formatDateTime(date) {
  if (!date) return ''
  
  if (typeof date === 'string') {
    date = new Date(date)
  }
  
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date)
}

/**
 * Get file type category based on extension
 */
export function getFileType(filename) {
  if (!filename) return 'unknown'
  
  const ext = filename.split('.').pop().toLowerCase()
  
  if (['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(ext)) {
    return 'image'
  } else if (['csv', 'xlsx', 'xls'].includes(ext)) {
    return 'data'
  } else if (['json'].includes(ext)) {
    return 'json'
  } else {
    return 'document'
  }
}

/**
 * Get current user or create one if not exists
 */
export function getCurrentUser() {
  let userId = localStorage.getItem('userId')
  
  if (!userId) {
    userId = generateId()
    localStorage.setItem('userId', userId)
  }
  
  return userId
}
